import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { ReactElement, useMemo } from 'react';
import { DefaultCell } from '@dmc/ui/tables';
import { EmptyCell } from '../../formatters/genericFormatters';
import { CustomCellRendererProps } from 'ag-grid-react';

// Todo: This cell renderer can be replaced by a valueFormatter and getQuickFilterText callback.
export function DateOnlyRenderer<T>({
  value,
  ...otherProps
}: CustomCellRendererProps<T, string>): ReactElement {
  const { showDateOnlyFromIso } = useLocaleFormatter();

  const message = useMemo(() => {
    return value ? showDateOnlyFromIso(value) : EmptyCell;
  }, [value, showDateOnlyFromIso]);

  return (
    <DefaultCell
      {...otherProps}
      value={message}
      valueFormatted={undefined} // Prevent the AG Grid default formatted value from being used
    />
  );
}

export default DateOnlyRenderer;
